import { ErrorHandler, inject } from '@angular/core';
import { AnimationDialogService } from '@pc/dialog-abstract';
import { Dialog } from '@angular/cdk/dialog';
import { MainStore } from '../../store/main-store/main-store';
import { SmartlookService } from '@pc/smartlook';
import { HttpErrorResponse } from '@angular/common/http';
import { EnvironmentService } from '../../environment/environment.service';
import { GetInTouchPopupComponent } from '../../components/get-in-touch-popup/get-in-touch-popup.component';
import { GetInTouchPopupState } from '../../components/get-in-touch-popup/get-in-touch-popup';
import { ProgressStepperService } from '@pc/progress-stepper';
import { ProcessTypeStore } from '../../store/process-type-store/process-type-store';

declare const window: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  location: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dataLayer: any;
};
export class GlobalErrorHandler implements ErrorHandler {
  private animationDialogService = inject(AnimationDialogService);
  private progressStepperService = inject(ProgressStepperService);
  private smartlookService = inject(SmartlookService);
  private mainStore = inject(MainStore);
  private dialog = inject(Dialog);
  private enviromentService = inject(EnvironmentService);
  private processTypeStore = inject(ProcessTypeStore);

  handleError(error: Error): void {
    if (!error) return;

    this.mainStore.setIsLoading(false);
    this.smartlookService.logError(error);
    const apiURL = this.enviromentService.environment.url.apiUrl;

    if (!this.enviromentService.isActive()) return;

    if (error instanceof HttpErrorResponse && error.url?.includes(apiURL)) {
      this.processTypeStore.setApiError(error);
      this.pushError(error.message);
      const dialog = this.animationDialogService.openDialogWithAnimation(this.dialog, GetInTouchPopupComponent, {
        state: GetInTouchPopupState.generalError,
        message: error.error?.clientMessage
      });

      dialog.closed.subscribe((leadSent) => {
        if (!leadSent) {
          window.location.reload();
        }
      });
    }
  }

  private pushError(errorMessage: string): void {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: 'Errors',
      section: this.progressStepperService.currentStep().name,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      error_despriction: errorMessage
    });
  }
}
